import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import noPhoto from '@propertypal/shared/src/resources/fallbacks/no-photo-icon.png';
import { MarkerProperty } from '@propertypal/shared/src/types/marker';
import { getMainImage } from '@propertypal/shared/src/utils/property';
import { MAP_IMAGE_LOCATOR } from '@propertypal/web-app/src/constants/imageLocator';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import PropertyPrice from '../property/PropertyPrice';
import { Heading, Text } from '../typography';
import { CloseIcon, Container, Content, PropertyImage, RelativeBox, SliderBar } from './MapProperty.style';

interface Props {
  properties: MarkerProperty[];
  onClose: () => void;
}

const MapProperty: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const [property, setProperty] = useState<MarkerProperty>(props.properties[0]);
  const index = props.properties.indexOf(property);
  // @ts-ignore
  const [mainImage] = getMainImage(property, MAP_IMAGE_LOCATOR);

  const nextProperty = () => {
    setProperty(props.properties[index + 1]);
  };

  const prevProperty = () => {
    setProperty(props.properties[index - 1]);
  };

  useEffect(() => {
    setProperty(props.properties[0]);
  }, [props.properties]);

  return (
    <Container data-testid="mapProperty">
      {props.properties.length > 1 && (
        <SliderBar>
          {index > 0 && (
            <button onClick={prevProperty} type="button" data-testid="mapPropertyChevLeft">
              <FontAwesomeIcon icon={faChevronLeft} color={theme.white} style={{ fontSize: 20 }} />
            </button>
          )}

          <Text color={theme.white} style={{ flex: 1, lineHeight: 0.8, padding: '0 10px' }}>
            Property {index + 1} of {props.properties.length}
          </Text>

          {index < props.properties.length - 1 && (
            <button onClick={nextProperty} type="button" data-testid="mapPropertyChevRight">
              <FontAwesomeIcon icon={faChevronRight} color={theme.white} style={{ fontSize: 20 }} />
            </button>
          )}
        </SliderBar>
      )}

      <RelativeBox>
        <CloseIcon onClick={props.onClose}>
          <FontAwesomeIcon color={theme.textLight} icon={faTimes} style={{ fontSize: 20 }} />
        </CloseIcon>

        <Content href={property.path} prefetch={false}>
          <PropertyImage src={mainImage || noPhoto.src} alt={`${property.displayAddress} photo`} />

          <div>
            <Heading fontSize={16} mb={10}>
              {property.displayAddress}
            </Heading>

            <PropertyPrice
              alternativeCurrencyPrice={property.alternativeCurrencyPrice}
              price={property.price}
              fontSize={14}
              status={property.status}
              comingSoonText={property.comingSoonText}
            />

            <Text fontSize={14} mt={10}>
              {property.briefText}
            </Text>
          </div>
        </Content>
      </RelativeBox>
    </Container>
  );
};

export default MapProperty;
